// extracted by mini-css-extract-plugin
export default {"container":"styles_container__iFqYy","title":"styles_title__ZMXHd","description":"styles_description__gaYoh","button":"styles_button__+OzlM"};